import React, { useState, useEffect, useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from "@mui/material";
import axios from "axios";
import { ThemeContext } from "../../context/ThemeContext";
import { getColors } from "../../themes/theme";

export const EditTreatmentsDialog = ({
  open,
  onClose,
  token,
  selectedTreatmentIds,
  onSave,
}) => {
  const [allTreatments, setAllTreatments] = useState([]);
  const [selectedTreatments, setSelectedTreatments] = useState([]);
  const { darkMode } = useContext(ThemeContext);
  useEffect(() => {
    const fetchTreatments = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/treatment`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setAllTreatments(response.data);
        setSelectedTreatments(
          response.data.filter((treatment) =>
            selectedTreatmentIds.includes(treatment.id)
          )
        );
      } catch (err) {
        console.error("Error fetching treatments:", err);
      }
    };

    if (open) {
      fetchTreatments();
    }
  }, [open, token, selectedTreatmentIds]);

  const handleAddToSelected = (treatment) => {
    setSelectedTreatments((prev) => [...prev, treatment]);
  };

  const handleRemoveFromSelected = (treatmentId) => {
    setSelectedTreatments((prev) =>
      prev.filter((treatment) => treatment.id !== treatmentId)
    );
  };

  const availableTreatments = allTreatments.filter(
    (treatment) =>
      !selectedTreatments.some((selected) => selected.id === treatment.id)
  );

  const handleSave = () => {
    onSave(selectedTreatments.map((treatment) => treatment.id));
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Edit Treatments</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Selected Treatments
          </Typography>
          <Box display="grid" gridTemplateColumns="repeat(3, 1fr)" gap={2}>
            {selectedTreatments.map((treatment) => (
              <Button
                key={treatment.id}
                variant="outlined"
                onClick={() => handleRemoveFromSelected(treatment.id)}
                sx={{ height: "45px" }}
              >
                {treatment.name}
              </Button>
            ))}
          </Box>
        </Box>
        <Box>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Available Treatments
          </Typography>
          <Box display="grid" gridTemplateColumns="repeat(3, 1fr)" gap={2}>
            {availableTreatments.map((treatment) => (
              <Button
                key={treatment.id}
                variant="outlined"
                onClick={() => handleAddToSelected(treatment)}
                sx={{ height: "45px" }}
              >
                {treatment.name}
              </Button>
            ))}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          sx={{
            color: darkMode ? getColors.appBarBgLight : getColors.appBarBgDark,
            "&: hover": {
              background: "none",
              color: getColors.primaryMain,
            },
          }}
        >
          Cancel
        </Button>
        <Button variant="contained" onClick={handleSave}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
